import {
  DELETE_REGISTER_PROFESSIONAL_CATEGORY,
  DELETE_REGISTER_PROFESSIONAL_CATEGORY_SUCCESS,
  DELETE_REGISTER_PROFESSIONAL_CATEGORY_FAILURE,
} from 'store/deleteRegisterProfessionalCategory/deleteRegisterProfessionalCategoryAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteRegisterProfessionalCategoryReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DELETE_REGISTER_PROFESSIONAL_CATEGORY:
      return { ...state, loading: true };
    case DELETE_REGISTER_PROFESSIONAL_CATEGORY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_REGISTER_PROFESSIONAL_CATEGORY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteRegisterProfessionalCategoryReducer;
